import React, { PureComponent, Fragment } from 'react';
// Components
import styles from './chart.scss';
import { NAVIGATOR_HEIGHT } from './utils';
import Mouse from 'core/mouse';
import DragOverlay from 'components/drag-overlay';

interface ChartNavigatorHandleProps {
  offset: number;
  width: number;
  end: boolean;
  onChange: (offset: number) => void;
}
export default class ChartNavigatorHandle extends PureComponent<ChartNavigatorHandleProps> {
  state = {
    dragging: false
  };

  handleDragStart = (e: MouseEvent) => {
    e.stopPropagation();
    this.setState({ dragging: true });
    Mouse.on('mousemove', this.handleDrag);
    Mouse.on('mouseup', this.handleDragEnd);
    this.initOffset = this.props.offset;
  };

  handleDrag = () => {
    const dOffset = Mouse.getDownDistX() / this.props.width;
    this.props.onChange(Math.max(0, Math.min(1, this.initOffset + dOffset)));
  };

  handleDragEnd = () => {
    this.setState({ dragging: false });
    Mouse.off('mousemove', this.handleDrag);
    Mouse.off('mouseup', this.handleDragEnd);
  };
  render() {
    const { offset, width, end = 0 } = this.props;
    return (
      <Fragment>
        <DragOverlay show={this.state.dragging} />
        <rect
          onMouseDown={this.handleDragStart}
          x={offset * width - 8 * end}
          y={NAVIGATOR_HEIGHT / 4}
          width={8}
          height={NAVIGATOR_HEIGHT / 2}
          rx={3}
          ry={3}
          className={styles.handle}
        />
      </Fragment>
    );
  }
}
